import smoothscroll from "smoothscroll-polyfill";

export const scrollTop = () => {
  smoothscroll.polyfill();
  const pagetopBtn = document.getElementById("scroll-top");
  pagetopBtn.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
};
